import angular from 'angular';

import {Directive, Module} from 'app/decorators';

@Module({
    name: "app.directives.loading",
})
@Directive('loading-container', function () {
    "ngInject";
    return {
        restrict: "A",
        scope: false,
        link: function(scope, element, attrs) {
            var loadingLayer = angular.element("<div class='loading'></div>");
            element.append(loadingLayer);
            element.addClass("loading-container");
            scope.$watch(attrs.loadingContainer, function(value) {
                loadingLayer.toggleClass("ng-hide", !value);
            });
        },
    };
})
export default class D {}



// WEBPACK FOOTER //
// ./src/app/directives/loading.js